import type { FC } from 'react'
import {
  AgreedPlaceIllustration,
  HomeIllustration,
  LockerClosedIllustration,
  ServicePointIllustration,
  LockerSpIllustration,
} from '@dhl-ui/illustrations'
import { type PreferenceType } from '@dhl/receiver-preference-api'

type IllustrationType = PreferenceType | 'LockerDelivery' | 'LockerSpDelivery'

type Props = {
  type?: IllustrationType
}

export const DeliveryPreferenceIllustration: FC<Props> = ({ type }) => {
  switch (type) {
    case 'AgreedPlaceDelivery':
      return <AgreedPlaceIllustration data-testid="agreed-place-delivery-illustration" />
    case 'LockerDelivery':
      return <LockerClosedIllustration data-testid="locker-delivery-illustration" />
    case 'LockerSpDelivery':
      return <LockerSpIllustration data-testid="locker-sp-delivery-illustration" />
    case 'ServicePointDelivery':
      return <ServicePointIllustration data-testid="service-point-delivery-illustration" />
    default:
      return <HomeIllustration data-testid="door-delivery-illustration" />
  }
}
